<template>
  <div class="orderList">
    <div class="head">
        <div style="flex:4;padding-left:20px;">
          <span style="flex:2;">宝贝</span>
          <span style="flex:1;">单价</span>
          <span style="flex:1;">数量</span>
        </div>
        <div style="flex:4;padding-right:20px;">
          <span style="flex:1;">退款金额</span>
          <span style="flex:1;">申请时间</span>
          <span style="flex:1;">状态</span>
          <span style="flex:1;">操作</span>
        </div>
    </div>
    <div v-if="afterSaleList.length>0">
      <div class="content" v-for="(item,index) in afterSaleList" :key="index">
          <div class="top">
              <div class="left">
                  <!-- <span class="shopName" @click="toStore(item.shopId)"><img :src="item.shopLogo" alt="">{{item.shopName}}</span> -->
				          <el-checkbox v-model="item.checked" @change="changeStatus(item)" style="margin-left: 5px;"></el-checkbox>
                  <span class="orderCode" style="margin-left: 5px;">售后编号：{{item.afterId}}</span>
              </div>
          </div>
          <div class="productBox">
              <div class="product">
                  <div class="left fs13">
                      <div class="box" v-for="(pro,inx) in item.cartInfo" :key="inx">
                          <div class="desc cur-poi" @click="toProductDetail(pro)">
                            <div style="border:1px solid #efefef;margin-right: 10px;">
                              <img :src="pro.productInfo.image" alt="">
                            </div>
                            <div>
                              <p class="name">{{pro.productInfo.storeName}}</p>
<!--                                  <p class="size font-color-999"><span >{{pro.productInfo["attrInfo"].sku}}</span></p>-->
                            </div>
                          </div>
                          <div class="price">¥{{pro.productInfo.price}}</div>
                          <div class="num">{{pro.cartNum}}</div>
                      </div>
                  </div>
                  <div class="right" :class="item.cartInfo.length>1?'right_line':''">
                      <div class="actualPay">
                          <div>
                          <p class="fs13 mar-bot-5">¥{{item.payPrice}}</p>
                        </div>
                      </div>
                      <div class="applicationTime">{{item.createTime}}</div>
                      <div class="status">
                      <div>
                          <p class="fs13 mar-bot-5 font-color-FF7" v-if="item._status._type==-1">审核中</p>
                            <p class="fs13 mar-bot-5 font-color-FF7" v-if="item._status._type==-2">已退款</p>
                          <!-- <p class="fs13 mar-bot-5 font-color-FF7" v-if="item.afterState==3">退货中</p>
                          <p class="fs13 mar-bot-5 font-color-71B" v-if="item.afterState==4">退款成功</p>
                          <p class="fs13 mar-bot-5 font-color-FF7" v-if="item.afterState==5">退款失败</p>
                          <p class="fs13 mar-bot-5 font-color-FF7" v-if="item.afterState==6">审核不通过</p>
                          <p class="fs13 mar-bot-5 font-color-FF7" v-if="item.afterState==7">评审中</p>
                          <p class="fs13 mar-bot-5 font-color-999" v-if="item.afterState==8">退货完成，拒绝退款</p>
                          <p class="fs13 mar-bot-5 font-color-999" v-if="item.afterState==9">已关闭</p>
                          <p class="fs13 mar-bot-5 font-color-71B" v-if="item.afterState==10">审核通过</p> -->
                      </div>
                      </div>
                      <div class="operate">
                          <el-button size="small" @click="toAfterSaleDetail(item.afterId,item.orderId)">售后详情</el-button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <el-pagination :current-page="page" :page-size="5" @current-change="handleCurrentChange" background layout='prev, pager, next' :total='total'></el-pagination>
    </div>
    <div class="noorder" v-else>
        <img src="../../../static/image/noorder@2x.png" alt="">
        <p class="fs20 font-color-999">你还没有售后订单哦～</p>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
    props: ['afterSaleList', 'page', 'total'],
    data () {
        return {
            state: 1
        }
    },
	created() {
	},
    methods: {
		changeStatus (item) {
		},
        // 分页器跳转
        handleCurrentChange (val) {
            this.$emit('handleCurrentChange', val)
        },
        // 跳转到店铺
        toStore (id) {
            // this.$router.push({
            //     path: '/store',
            //     query: {
            //         shopData: {shopId: id}
            //     }
            // })
        },
        // 跳转到售后详情
        toAfterSaleDetail (aid, oid) {
            this.$router.push({
                path: '/afterSale',
                query: {
                    afterId: aid,
                    orderId: oid,
                    state: 2
                }
            })
        },
        ...mapMutations({
          setCurrentPro: 'SET_CURRENTPRO'
        }),
        // 跳转到商品详情
        toProductDetail (item) {
			item.id = item.productId
          this.setCurrentPro(item)
          // this.$router.push({path: '/productDetail'})
		  this.$router.push({path: '/productDetail?productId='+item.id})
        }
    }
}
</script>
<style lang="scss" scoped>
.orderList{
    width: 100%;
    .noorder{
        width: 100%;
        text-align: center;
        padding: 100px 0;
        p{
            margin-bottom: 20px;
        }
        .el-button{
            background-color: #D22929;
            color: #FFFFFF;
            font-weight: normal;
            border-radius: 0;
        }
    }
    .head{
        box-sizing: border-box;
        width: 100%;
        height: 34px;
        background-color: #f5f5f5;
        display: flex;
        align-items: center;
        font-size: 12px;
        text-align: center;
        margin-bottom: 10px;
        color: #666;
        div{
            display: flex;
        }
    }
    .content{
        width: 100%;
        margin-bottom: 20px;
        border: 1px solid #E5E5E5;
        border-bottom: 0;
        box-sizing: border-box;
        .top{
            width: 100%;
            height: 34px;
            font-size: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: #F3F3F3;
            .left{
                display: flex;
				        align-items: center;
                .shopName{
                    margin-left: 20px;
                    margin-right: 60px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    img{
                        width: 16px;
                        height: 16px;
                        vertical-align: middle;
                        margin-right: 5px;
                    }
                }
                .time{
                    margin-right: 60px;
                }
            }
        }
        .productBox{
            width: 100%;
            box-sizing: border-box;
            .product{
                width: 100%;
                display: flex;
                .left{
                    flex: 4;
                    .box{
                        padding: 4px 0 4px 4px;
                        display: flex;
                        border-bottom: 1px solid #E5E5E5;
                        .desc{
                            flex: 2;
                            display: flex;
                            img{
                                width: 50px;
                                height: 50px;
                            }
                            div{
                                display: flex;
                                flex-direction: column;
                                justify-content: space-between;
                                .name{
                                    font-size: 10px;
                                    &:hover {
                                      color:red;
                                    }
                                }
                                .size{
                                    font-size: 10px;
                                    span{
                                        margin-right: 10px;
                                    }
                                    span:last-child{
                                        margin-right: 0;
                                    }
                                }
                            }
                        }
                        .price,.num{
                            flex: 1;
                            display: flex;
                            font-size: 10px;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                }
                .right{
                    padding: 0 0 4px 0;
                    flex: 4;
                    display: flex;
                    border-bottom: 1px solid #E5E5E5;
                    .actualPay,.applicationTime,.status,.operate{
                        font-size: 10px;
                        flex: 1;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        text-align: center;
                        div{
                            text-align: center;
                        }
                        p{
                          font-size: 10px;
                        }
                        .el-button{
                            border: 1px solid #D22929;
                            color: #D22929;
                            border-radius: 0;
                        }
                    }
                }
                .right_line{
                    border-left: 1px solid #E5E5E5;
                }
            }
        }
    }
    >>>.el-pagination{
        margin-top: 40px;
        text-align: right;
        .el-pager{
            li:not(.disabled):hover{
                color: #D22929;
            }
            li:not(.disabled).active{
                background-color: #D22929;
            }
            li:not(.disabled).active:hover{
                color: #F4F4F5;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/base/aftersaleList.vue